import React, {useState} from 'react';
import './Body.css';

export default function ServiceBody() {
    const [facility, setFacility] = useState("");
    const [speciality, setSpeciality] = useState("");
    const [LGA, setLGA] = useState("");
    const [ownership, setOwnership] = useState("");

    return (
        <div className='ServiceBody'>
            <div className='ServiceBody__Search'>
                <div className='ServiceBody__Input'>
                    <input type="text" placeholder='Alagbaka Akure, ondo state' required />
                </div>
                <div className='ServiceBody__Input__Dropdown'>
                    <div className='div__dropdown'>
                            <select value={facility} onChange={e => setFacility(e.target.value)}
                            className={(facility.length > 3) ? "complete" : ""}
                            >
                                <option className='option' aria-disabled>Facility Type</option>
                                <option value="Akure">Akure</option>
                                <option value="Niger">Niger</option>
                                <option value="Lagos">Lagos</option>

                            </select>
                            <select value={speciality} onChange={e => setSpeciality(e.target.value)}
                            className={(speciality.length > 3) ? "complete" : ""}>
                                <option className='option'>Speciality</option>
                            </select>
                            <select value={LGA} onChange={e => setLGA(e.target.value)}
                            className={(LGA.length > 3) ? "complete" : ""}>
                                <option className='option'>LGA</option>
                            </select>
                            <select value={ownership} onChange={e => setOwnership(e.target.value)}
                            className={(ownership.length > 3) ? "complete" : ""}>
                                <option className='option'>Ownership</option>
                            </select>
                    </div>
                </div>
            </div>
            <div className='ServiceBody__Result'>
                <p>Search Result</p>
                <div className='ServiceBody__Result__Container'>
                    <div className='ServiceBody__Result__row'>
                        <div className='ServiceBody__Result__row__600'>
                            <div className='blank'>

                            </div>
                            <div className='blank'>

                            </div>
                        </div>
                        <div className='ServiceBody__Result__row__600'>
                            <div className='blank'>

                            </div>
                            <div className='blank'>

                            </div>
                        </div>

                    </div>
                    <div className='ServiceBody__Result__row'>
                        <div className='ServiceBody__Result__row__600'>
                            <div className='blank'>

                            </div>
                            <div className='blank'>

                            </div>
                        </div>
                        <div className='ServiceBody__Result__row__600'>
                            <div className='blank'>

                            </div>
                            <div className='blank'>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}